/**
 * Do not edit directly
 * Generated on Fri, 11 Nov 2022 09:04:27 GMT
 */

module.exports = {
  'd-heading-1-eng': {
    fontSize: '92px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '92px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-2-eng': {
    fontSize: '78px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '78px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-3-eng': {
    fontSize: '64px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '64px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-4-eng': {
    fontSize: '48px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '48px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-5-eng': {
    fontSize: '34px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '34px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-6-eng': {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '22.08px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-sub-heading-eng': {
    fontSize: '36px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '39.6px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'body-text-large-heading-eng': {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '26px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'body-text-large-eng': {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '26px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'body-text-heading-eng': {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '22px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'body-text-eng': {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '22px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'button-text-eng': {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '22px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'small-text-eng': {
    fontSize: '11px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'small-text-bold-eng': {
    fontSize: '11px',
    textDecoration: 'none',
    fontFamily: 'Brother 1816',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'm-heading-1-eng': {
    fontSize: '52px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '47.84px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-2-eng': {
    fontSize: '44px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '40.48px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-3-eng': {
    fontSize: '38px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '34.96px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-4-eng': {
    fontSize: '32px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '29.44px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-5-eng': {
    fontSize: '26px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '23.92px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-6-eng': {
    fontSize: '20px',
    textDecoration: 'none',
    fontFamily: 'Benton Sans Compressed',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-1-kor': {
    fontSize: '92px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '101.2px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-2-kor': {
    fontSize: '78px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '85.8px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-3-kor': {
    fontSize: '64px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '70.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-4-kor': {
    fontSize: '48px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '52.8px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-5-kor': {
    fontSize: '34px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '37.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'd-heading-6-kor': {
    fontSize: '24px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '26.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'sub-heading-kor': {
    fontSize: '36px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '43.2px',
    paragraphIndent: 0,
    paragraphSpacing: 36,
    textCase: 'none',
  },
  'body-text-large-bold-kor': {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '26px',
    paragraphIndent: 0,
    paragraphSpacing: 13,
    textCase: 'none',
  },
  'body-text-large-kor': {
    fontSize: '18px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '26px',
    paragraphIndent: 0,
    paragraphSpacing: 13,
    textCase: 'none',
  },
  'body-text-bold-kor': {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    paragraphIndent: 0,
    paragraphSpacing: 24,
    textCase: 'none',
  },
  'body-text-kor': {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '24px',
    paragraphIndent: 0,
    paragraphSpacing: 24,
    textCase: 'none',
  },
  'button-text-kor': {
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '22px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'small-text-kor': {
    fontSize: '11px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'none',
  },
  'small-text-bold-kor': {
    fontSize: '11px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '18px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-1-kor': {
    fontSize: '52px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '57.2px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-2-kor': {
    fontSize: '44px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '48.4px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-3-kor': {
    fontSize: '38px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '41.8px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-4-kor': {
    fontSize: '32px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '35.2px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-5-kor': {
    fontSize: '26px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '28.6px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-heading-6-kor': {
    fontSize: '20px',
    textDecoration: 'none',
    fontFamily: 'Godo B',
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '22px',
    paragraphIndent: 0,
    paragraphSpacing: 0,
    textCase: 'uppercase',
  },
  'm-sub-heading-kor': {
    fontSize: '30px',
    textDecoration: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 0,
    lineHeight: '36px',
    paragraphIndent: 0,
    paragraphSpacing: 36,
    textCase: 'none',
  },
};
